import { Exchange, Account, AccountUser } from '../../types/exchange'
import { apiRequest } from './client'

export const exchangeApi = {
  async getExchanges(): Promise<Exchange[]> {
    const data = await apiRequest<{ exchanges: Exchange[] }>('/exchanges')
    return data.exchanges
  },

  async getExchange(id: string): Promise<Exchange> {
    const data = await apiRequest<{ exchange: Exchange }>(`/exchanges/${id}`)
    return data.exchange
  },

  async createExchange(params: { name: string; accountId?: string }): Promise<Exchange> {
    const data = await apiRequest<{ exchange: Exchange }>('/exchanges', {
      method: 'POST',
      body: { name: params.name, accountId: params.accountId },
    })
    return data.exchange
  },

  async updateExchange(id: string, updates: Partial<Exchange>): Promise<Exchange> {
    const data = await apiRequest<{ exchange: Exchange }>(`/exchanges/${id}`, {
      method: 'PATCH',
      body: updates,
    })
    return data.exchange
  },

  async getAccounts(): Promise<Account[]> {
    const data = await apiRequest<{ accounts: Account[] }>('/accounts')
    return data.accounts
  },

  async createAccount(params: { name: string }): Promise<Account> {
    const data = await apiRequest<{ account: Account }>('/accounts', {
      method: 'POST',
      body: params,
    })
    return data.account
  },

  async getAccountUsers(accountId: string): Promise<AccountUser[]> {
    const data = await apiRequest<{ users: AccountUser[] }>(`/accounts/${accountId}/users`)
    return data.users
  },

  async addAccountUser(
    accountId: string,
    params: { userId: string; role: AccountUser['role']; allowedExchanges?: string[] }
  ): Promise<AccountUser> {
    const data = await apiRequest<{ accountUser: AccountUser }>(`/accounts/${accountId}/users`, {
      method: 'POST',
      body: params,
    })
    return data.accountUser
  },

  async getExchangeUsers(exchangeId: string): Promise<any[]> {
    const data = await apiRequest<{ users: any[] }>(`/exchanges/${exchangeId}/users`)
    return data.users
  },

  async addExchangeUser(
    exchangeId: string,
    params: {
      email?: string
      userId?: string
      permissionLevel: string
      userType: string
      featurePermissions?: any
      customTypeName?: string
    }
  ): Promise<any> {
    const data = await apiRequest<{ permission: any }>(`/exchanges/${exchangeId}/users`, {
      method: 'POST',
      body: params,
    })
    return data.permission
  },

  async updateExchangeUserPermission(
    exchangeId: string,
    userId: string,
    updates: Partial<any>
  ): Promise<any> {
    const data = await apiRequest<{ permission: any }>(`/exchanges/${exchangeId}/users/${userId}`, {
      method: 'PATCH',
      body: updates,
    })
    return data.permission
  },

  async removeExchangeUserPermission(exchangeId: string, userId: string): Promise<void> {
    await apiRequest(`/exchanges/${exchangeId}/users/${userId}`, { method: 'DELETE' })
  },

  async searchUsers(query: string, _accountId?: string): Promise<any[]> {
    const data = await apiRequest<{ users: any[] }>(`/exchanges/users/search?q=${encodeURIComponent(query)}`)
    return data.users
  },

  async ensureDemoExchange(): Promise<Exchange> {
    const data = await apiRequest<{ exchange: Exchange }>('/exchanges/ensure-demo', {
      method: 'POST',
    })
    return data.exchange
  },

  async getInvites(): Promise<any[]> {
    return []
  },

  async acceptInvite(_inviteId: string): Promise<any> {
    throw new Error('Invites not yet implemented')
  },
}
